import React, { useState } from "react";
import pageMessageBroker from './page_message_broker';

export default function ExtractButton({document_id, file_type}) {
  //console.log("ExtractButton props: ", document_id, file_type);
  const [state, setState] = useState('ready');

  const jobType = {
    "Booklet": "Jobs::ExtractPlanDesignJob",
    "Renewal": "Jobs::ExtractRenewalRateSheetJob",
    "Contract": "Jobs::ExtractPlanDesignJob",
    "Claims Experience": "Jobs::ExtractClaimsExperienceJob",
    "Claims Experience Breakdown": "Jobs::ExtractClaimsExperienceBreakdownJob",
    "Billing Statement": "Jobs::ExtractEmployeeCensusJob",
  }[file_type] || "Jobs::ExtractPlanDesignJob";
  const buttonText = {
    "Booklet": "Extract Plan Design",
    "Renewal": "Extract Renewal",
    "Contract": "Extract Plan Design",
    "Claims Experience": "Extract Claims Experience",
    "Claims Experience Breakdown": "Extract Claims Experience Breakdown",
    "Billing Statement": "Extract Employee Census",
  }[file_type] || "Extract Plan Design";

  const handleClick = () => {
    if (state !== 'ready') { return; }

    setState('loading');

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch(`/workspaces/${current_workspace.id}/jobs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        job: {
          type: jobType,
          input: {
            document: `document_${document_id}`,
          },
        },
      }),
    }).then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        setState('ready');
        throw new Error("Network response was not ok");
      }
    }).then((data) => {
      const job_path = `/workspaces/${current_workspace.id}/jobs/${data.job.id}`;
      window.location.href = job_path;
      // setState('ready');
      // pageMessageBroker.dispatch("notice", {
      //   text: <a className="link" href={}>Extract Plan Design job created</a>
      // })
    }).catch((error) => {
      setState('ready');
      pageMessageBroker.dispatch("notice", { text: "Error creating job" })
    });
  }

  return (
    <button className={"button button__primary whitespace-nowrap" + (state !== "ready" ? " button__disabled" : "")} onClick={handleClick}>
      <span>
        {buttonText}
        {
          state === "loading" && (
            <svg className="w-5 h-5 animate-spin inline-block ml-2" viewBox="0 0 100 100">
              <circle
                cx="50"
                cy="50"
                r="45"
                stroke="lightgray"
                strokeWidth="10"
                strokeDasharray="220 80"
                fill="none"
              />
            </svg>
          )
        }
      </span>
    </button>
  );
}
